let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2bqSD")).then(() => parcelRequire('c1E8Q'));